import { Navigate, useParams } from 'react-router-dom';

/**
 * The old business detail (/businesses/:id) and edit (/businesses/:id/edit)
 * pages are gone — Business settings replaced both, and nothing in the app
 * linked to them any more. Keep the URLs working for bookmarks by sending them
 * to that business's settings.
 */
export default function BusinessSettingsRedirect() {
  const { id } = useParams();

  return <Navigate to={`/businesses/${id}/settings`} replace />;
}
